export { default } from "./diagram2.component";
